<div class="flex flex-row py-2 mx-4">
  <h1 fxFlex="100">Users</h1>
  <button
    fxFlex="0 0 auto"
    mat-raised-button
    color="primary"
    (click)="addUser()"
  >
    Add User
  </button>
</div>
<div
  class="flex flex-grow basis-full flex-col items-stretch justify-start mx-4 bg-red-100"
>
  <ag-grid-angular
    #agGrid
    class="ag-theme-alpine h-full"
    [columnDefs]="columns"
    [rowData]="users"
    rowSelection="multiple"
    [gridOptions]="gridOptions"
    (gridReady)="gridReady()"
    (cellClicked)="onCellClicked($event)"
  ></ag-grid-angular>
</div>

<a class="app-action" (click)="addUser()">
  <button mat-fab fxHide fxShow.lt-md>+</button>
</a>
